import { render, staticRenderFns } from "./settings-company.vue?vue&type=template&id=2161ac96&scoped=true&"
import script from "./settings-company.ts?vue&type=script&lang=ts&"
export * from "./settings-company.ts?vue&type=script&lang=ts&"
import style0 from "./settings-company.vue?vue&type=style&index=0&id=2161ac96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2161ac96",
  null
  
)

export default component.exports